import http from '../app/httpService';

const apiEndpoint = process.env.REACT_APP_MARKET_DATA_API+"subscribable/";

export async function getSubscribables() {
  const {data: Subscribables} = await http.get(apiEndpoint);
  return Subscribables;
}